import { Serializable } from '@admin/core/models/serializable';

export class StaticContentFilterModel
  implements Serializable<StaticContentFilterModel>
{
  fromObject(obj: any): StaticContentFilterModel {
    throw new Error('Not Implemented');
  }
  toObject() {
    let result = {
      Alias: this.alias,
      PrimaryLanguage: this.primaryLanguage,
      AlternativeLanguage: this.alternativeLanguage,
      StaticContentId: this.staticContentId,
    };
    return result;
  }

  public alias: string;
  public primaryLanguage: string;
  public alternativeLanguage: string;
  public staticContentId: number;

  constructor() {
    this.alias = null;
    this.primaryLanguage = null;
    this.alternativeLanguage = null;
    this.staticContentId = null;
  }
}
